import { useEffect, useState } from "react";
import "./ListingFilterSectionComponent.scss";
import { Dropdown } from "react-bootstrap";
import _ from "lodash";
import { SessionKeys } from "../../../../utils/AppUtils";
import { useTranslation } from "react-i18next";
const ListingFilterSectionComponent = (props) => {
  const {
    categoryList,
    selectedSubCatIds,
    selectedCatIds,
    subCatList,
    clearSearch,
    checkBoxOnChange,
    onSearchClicked,
    onSelectSubCat,
    showSearch,
    showSort,
    showFilter,
    showCategories,
    searchPlaceHolder,
    sortOption,
    filterOption,
    isLoading,
    setSelectedSort,
    setSelectedFilter,
    selectedSort,
    selectedFilter,
    entityType,
  } = props;
  const {t} = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [content, setContent] = useState({
    course: '',
    video: '',
    learningpath: '',
    coaching: ''
  });

  const textLocal = localStorage.getItem(SessionKeys.DYNAMIC_CONTENT);

  useEffect(() => {
    const storedData = localStorage.getItem(SessionKeys.DYNAMIC_CONTENT);
    if (storedData) {
      setContent(JSON.parse(storedData));
    }
  }, [textLocal]);

  // useEffect(() => {
  //     if (searchText.length > 2 ) onSearchClicked(searchText)
  //     else if(searchText.length === 0)
  // {
  //     onSearchClicked('')
  // }
  // }, [searchText])

  useEffect(() => {
    if (clearSearch) setSearchText("");
  }, [clearSearch]);

  const searchCliked = () => {
    onSearchClicked(searchText);
  };

  return (
    <>
      {(entityType === "lp" || entityType === "coaching") && false &&
        localStorage.getItem(SessionKeys.SHOW_LEADERBOARD) !== "false" && content?.learningpath && (
          <div className="mt-4">
            <div className="xsel-focus-box">
              {content?.learningpath}
            </div>
          </div>
        )}
      <div className="filter-section">
        <div className="d-sm-flex justify-content-sm-between">
          <div className="search-section-listing">
            {showSearch ? (
              <form className="confirm-row">
                <input
                  type="search"
                  className="form-control"
                  id="inputPassword2"
                  placeholder={searchPlaceHolder}
                  disabled={isLoading}
                  onChange={(e) => {
                    if (_.isEmpty(e.target.value)) {
                      setSearchText("");
                      onSearchClicked("");
                    } else {
                      setSearchText(e.target.value);
                    }
                  }}
                  value={searchText}
                />
                <button
                  type="button"
                  className={`confirm-btn ${
                    searchText === "" ? "cursor-not-allowed" : ""
                  }`}
                  disabled={isLoading}
                  onClick={() => searchCliked()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                      fill="black"
                    />
                  </svg>
                  {t("Search")}
                </button>
              </form>
            ) : (
              ""
            )}
          </div>
          <div className="filter-option-listing d-flex justify-content-end">
            {showFilter ? (
              <Dropdown
                className="filter-btn"
                onSelect={(e) => {
                  setSelectedFilter(_.toNumber(e));
                }}
              >
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.16666 10C4.16666 9.53978 4.53975 9.16669 4.99999 9.16669H15C15.4602 9.16669 15.8333 9.53978 15.8333 10C15.8333 10.4603 15.4602 10.8334 15 10.8334H4.99999C4.53975 10.8334 4.16666 10.4603 4.16666 10Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.66666 5.00002C1.66666 4.53978 2.03975 4.16669 2.49999 4.16669H17.5C17.9602 4.16669 18.3333 4.53978 18.3333 5.00002C18.3333 5.46026 17.9602 5.83335 17.5 5.83335H2.49999C2.03975 5.83335 1.66666 5.46026 1.66666 5.00002Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.66666 15C6.66666 14.5398 7.03975 14.1667 7.49999 14.1667H12.5C12.9602 14.1667 13.3333 14.5398 13.3333 15C13.3333 15.4603 12.9602 15.8334 12.5 15.8334H7.49999C7.03975 15.8334 6.66666 15.4603 6.66666 15Z"
                      fill="#415385"
                    />
                  </svg>
                  {t("Filter")}
                </Dropdown.Toggle>
                <Dropdown.Menu className="drop-down-menu">
                  {!_.isEmpty(filterOption) &&
                    filterOption.map((s, i) => {
                      return (
                        <Dropdown.Item
                          className={`dropdown-menu-item ${
                            selectedFilter == s.value ? "active" : ""
                          }`}
                          key={`filter-${i + 1}`}
                          eventKey={s.value}
                        >
                          {s.label}
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              ""
            )}
            {showSort ? (
              <Dropdown
                className="filter-btn"
                onSelect={(e) => {
                  setSelectedSort(_.toNumber(e));
                }}
              >
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.16666 10C4.16666 9.53978 4.53975 9.16669 4.99999 9.16669H15C15.4602 9.16669 15.8333 9.53978 15.8333 10C15.8333 10.4603 15.4602 10.8334 15 10.8334H4.99999C4.53975 10.8334 4.16666 10.4603 4.16666 10Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.66666 5.00002C1.66666 4.53978 2.03975 4.16669 2.49999 4.16669H17.5C17.9602 4.16669 18.3333 4.53978 18.3333 5.00002C18.3333 5.46026 17.9602 5.83335 17.5 5.83335H2.49999C2.03975 5.83335 1.66666 5.46026 1.66666 5.00002Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.66666 15C6.66666 14.5398 7.03975 14.1667 7.49999 14.1667H12.5C12.9602 14.1667 13.3333 14.5398 13.3333 15C13.3333 15.4603 12.9602 15.8334 12.5 15.8334H7.49999C7.03975 15.8334 6.66666 15.4603 6.66666 15Z"
                      fill="#415385"
                    />
                  </svg>
                  {t("Sort")}
                </Dropdown.Toggle>
                <Dropdown.Menu className="drop-down-menu">
                  {!_.isEmpty(sortOption) &&
                    sortOption.map((s, i) => {
                      return (
                        <Dropdown.Item
                          className={`dropdown-menu-item ${
                            selectedSort == s.value ? "active" : ""
                          }`}
                          key={`sort-${i + 1}`}
                          eventKey={s.value}
                        >
                          {s.label}
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              // <button className="filter-btn" type="button">
              // </button>
              ""
            )}
          </div>
        </div>
        {showCategories ? (
          <>
            <div className="customcheck-row">
              {categoryList.map((cat, i) => {
                return (
                  <div
                    className="form-check customcheck"
                    key={`cat-list-${i + 1}`}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                      checked={
                        selectedCatIds.includes(cat.id) || "" ? true : ""
                      }
                      disabled={isLoading}
                      onChange={(e) => {
                        checkBoxOnChange(e, cat.id);
                      }}
                    />
                    <label className="form-check-label" for="flexCheckDefault">
                      {cat.name}
                    </label>
                  </div>
                );
              })}
            </div>
            <div className="chiprow d-flex gap-2">
              {subCatList.map((sub, i) => {
                return (
                  <button
                    className={`chipbar reset-btn ${
                      selectedSubCatIds.includes(sub.id) ? "active" : ""
                    }`}
                    disabled={isLoading}
                    onClick={() => onSelectSubCat(sub.id)}
                    key={`sub-cat-list-${i + 1}`}
                  >
                    {sub.name}
                    {selectedSubCatIds.includes(sub.id) && (
                      <img src="/images/phip-close-icon.svg" alt="" />
                    )}
                  </button>
                );
              })}
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default ListingFilterSectionComponent;
